import { gql } from 'react-apollo';

export default gql`
  query currentTenant {
    currentTenant {
      _id
      name
      domainPrefix
      customDomain
      logoUrl
      faviconUrl
      marketingSiteUrl
      footerBrokerContent
      headerHtml
      bodyHtml
      availableListingTypes
      availableTransactionTypes
      areaTypes
      availableSectors
      primaryContactEmail
      anonymousHeaderText
      theme {
        enabled
        primaryColor
        secondaryColor
      }
    }
  }
`;



// WEBPACK FOOTER //
// ./src/apollo/queries/currentTenant.js